export default __webpack_public_path__ + "static/media/times-solid.0268d196.svg";